import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import Form, { ButtonItem, EmptyItem, FormRef, GroupItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { AssistitiApi, OperatoriApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { ClickEvent } from 'devextreme/ui/button';
import { Button, LoadPanel, Lookup } from 'devextreme-react';
import TenantContext from '../../contexts/tenantContext';
import { on } from 'events';
import { showError } from '../../utils/errorHandling';
import ComuneSelector, { ILocation } from '../comuneSelector/ComuneSelector';
import notify from 'devextreme/ui/notify';
import { isUndefined } from 'util';
import { useEntiDataSource } from '../../datasources/EntiDataSource';
import EmergenzaCreatePopup, { EmergenzaCreatePopupHandle } from './EmergenzaCreatePopup';
// import { useComuniDataSource } from '../../datasources/ComuniDataSource'; //todo: RGAM non esiste più datasource comuni.

type Props = {
  onChanged?: () => void;
}

export type EmergenzaEmptyPanelHandle = {
}

type state = {
}

const EmergenzaEmptyPanel: React.ForwardRefRenderFunction<EmergenzaEmptyPanelHandle, Props> = (props, ref) => {
  const { currentTenant } = useContext(TenantContext);
  const emergenzaCreatePopupRef = useRef<EmergenzaCreatePopupHandle>(null);

const addButtonClick = ()=> {
  emergenzaCreatePopupRef.current?.new();
};

  return (
    <React.Fragment>
      <div>
        Nessuna emergenza attiva
      </div>
      <br/>
      <div>
        <Button
          type='default'
          icon='add'
          text='Crea nuova'
          onClick={addButtonClick}
        />
      </div>

      <EmergenzaCreatePopup ref={emergenzaCreatePopupRef} onDataChanged={props.onChanged} />
    </React.Fragment>
  );
}

export default React.forwardRef(EmergenzaEmptyPanel);